import Axios from "axios";
import { ServiceApi } from "./Api";

export class ServiceConfig {
    async GetConfig() {
        var servico = await ServiceApi._getUrl();
        return await Axios.get(servico+'Api/Config/GetConfig');
    } 
}